export default "__VITE_ASSET__CrR$Nrp___"